import React, { Component } from "react";
import FlexView from "react-flexview";
import M from "moment";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../Services/Api";
import { mapToObjectDDL } from "../../../common/mapper";
import { fetchDataAsync } from "../../../../Services/Utils";

class PenyerahanBBNIndividuFilter extends Component {
  statusOptions = [
    { label: "Ready", value: "Ready" },
    { label: "Received", value: "Received" },
    { label: "Not Ready", value: "Not Ready" },
  ];

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: {},
      dataVariant: [],
      dataWarna: [],
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchDataVariant();
    // await this.fetchDataWarna();
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchDataVariant = async () => {
    try {
      let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataVariant: response.data.data.map((item) =>
            mapToObjectDDL(item.namaVariant, item.kodeVariant)
          ),
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataWarna = async (kodeWarna) => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByListKodeVariant,
        setError: this.props.setError,
        menuName: "Penyerahan BBN",
        args: kodeWarna,
      });

      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataWarna: response.data.data.map((item) => ({
            ...mapToObjectDDL(item.namaWarnaPabrik, item.id),
            kodeVariant: item.kodeVariant,
          })),
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleChangeVariant = async (value, { name }) => {
    const currKodeVariants = Array.isArray(value)
      ? value.map((v) => v.value)
      : [];

    const prevKodeVariants = Array.isArray(this.props.selectedData.kodeVariant)
      ? this.props.selectedData.kodeVariant.map((v) => v.value)
      : [];

    const removedVariants = prevKodeVariants.filter(
      (prev) => !currKodeVariants.includes(prev)
    );

    this.props.onValueChange(name, value);
    if (removedVariants.length > 0) {
      const prevWarna = this.props.selectedData.kodeWarna || [];
      const filteredWarna = prevWarna.filter(
        (warna) => !removedVariants.includes(warna.kodeVariant)
      );

      this.props.onValueChange("kodeWarna", filteredWarna);
    }

    await this.fetchDataWarna(currKodeVariants);
  };

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.visible}
        onClickClose={() => this.props.onClickClose()}
        content={
          <ModalContainer>
            <FlexView column>
              <FlexView column vAlignContent="center">
                <p>Tanggal Faktur Jual:</p>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleDate
                    date={this.props.selectedData.startPeriod}
                    onChange={(value) =>
                      this.props.onValueChange(
                        "startPeriod",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                  <span className="margin-bottom-20px">To</span>
                  <SimpleDate
                    date={this.props.selectedData.endPeriod}
                    onChange={(value) =>
                      this.props.onValueChange(
                        "endPeriod",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                </FlexView>
              </FlexView>
              <SimpleInput
                id="input_text_sales_invoice_number"
                name="facture"
                label="Nomor Faktur Jual"
                value={this.props.selectedData.facture}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_book_number"
                name="bookNumber"
                label="No Buku"
                value={this.props.selectedData.bookNumber}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_nama_varian"
                name="kodeVariant"
                label="Nama Varian"
                box="multiselect"
                isClearable={true}
                options={this.state.dataVariant}
                value={this.props.selectedData.kodeVariant}
                onChange={this.handleChangeVariant}
              />
              <SimpleDDL
                id={`select_options_nama_warna`}
                // box="search"
                name="kodeWarna"
                label="Nama Warna"
                box="multiselect"
                isClearable={true}
                options={this.state.dataWarna}
                value={this.props.selectedData.kodeWarna}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
                isDisabled={
                  !this.props.selectedData.kodeVariant ||
                  this.props.selectedData.kodeVariant.length === 0
                }
              />
              <SimpleInput
                id="input_text_stnk_name"
                name="stnkName"
                label="Nama STNK"
                value={this.props.selectedData.stnkName}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_buyer_name"
                name="buyerName"
                label="Nama Pembeli"
                value={this.props.selectedData.buyerName}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_no_rangka"
                name="frameNumber"
                label="Nomor Rangka"
                value={this.props.selectedData.frameNumber}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_no_mesin"
                name="engineNumber"
                label="Nomor Mesin"
                value={this.props.selectedData.engineNumber}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_status_stnk"
                box="search"
                name="stnkStatus"
                label="STNK"
                isClearable={true}
                options={this.statusOptions}
                value={this.props.selectedData.stnkStatus}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />
              <SimpleDDL
                id="select_options_status_tax_sheet"
                box="search"
                name="pajakStatus"
                label="Lembar Pajak"
                isClearable={true}
                options={this.statusOptions}
                value={this.props.selectedData.pajakStatus}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />
              <SimpleDDL
                id="select_options_status_plat_number"
                box="search"
                name="platStatus"
                label="Plat Kendaraan"
                isClearable={true}
                options={this.statusOptions}
                value={this.props.selectedData.platStatus}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />
              <SimpleDDL
                id="select_options_status_bpkb"
                box="search"
                name="bpkbStatus"
                label="BPKB"
                isClearable={true}
                options={this.statusOptions}
                value={this.props.selectedData.bpkbStatus}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />
            </FlexView>
            <FlexView hAlignContent="right" style={{ gap: "10px" }}>
              <SimpleButton
                secondary
                type="button"
                text={"Clear"}
                onClick={this.props.onClearForm}
              />
              <SimpleButton
                type="submit"
                text={"Terapkan"}
                onClick={this.props.onSubmit}
              />
            </FlexView>

            <SimpleLoadingOverlay active={this.state.loading} />
          </ModalContainer>
        }
      />
    );
  }
}

export default PenyerahanBBNIndividuFilter;
